import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalStyle } from './styles/globals';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import '@fontsource/inter'; // Importa a fonte Inter em toda a aplicação
import { ThemeProviderWithToggle } from './components/ThemeProviderToggle/ThemeProviderToggle';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProviderWithToggle>
      <GlobalStyle />
      <App />
    </ThemeProviderWithToggle>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
